import { h, defineAsyncComponent } from 'vue'
import type { PaywallRoute } from '@/@types/router-types'

const PaywallView = defineAsyncComponent(
	() => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/PaywallView.vue'),
)

type PaywallInstance = {
	name: PaywallRoute
	config: () => Promise<unknown>
}

export const paywallInstances: PaywallInstance[] = [
	{
		name: 'plan-glp-app-semaglutide',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/areas/glp-app/semaglutide'),
	},
	{
		name: 'plan-glp-app-tirzepatide',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/areas/glp-app/tirzepatide'),
	},
	{
		name: 'plan-glp-dm',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/areas/glp-dm/index'),
	},
	{
		name: 'plan-glp-app',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/areas/glp-app/index'),
	},
	{
		name: 'plan-glp-usa',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/areas/glp-usa/index'),
	},
	{
		name: 'plan-glp-app-v2',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/areas/glp-app-v2/index'),
	},
]

const paywallInstanceRoutes = paywallInstances.map((instance) => {
	const id = instance.name.replace('plan-', '')
	return {
		path: `/plan/${id}`,
		name: instance.name,
		component: {
			render: () =>
				h(PaywallView, {
					key: id,
					id,
					config: instance.config,
				}),
		},
	}
})

export default paywallInstanceRoutes
